import type { SavedPaymentMethod } from '../types';

/** True when every masked detail needed to show and later charge the method is present. */
export const isSavedPaymentMethodComplete = (method: SavedPaymentMethod) =>
  method.kind === 'card'
    ? !!(method.country && method.expMonth && method.expYear && method.lastFour)
    : !!(method.accountType && method.bankName && method.created && method.lastFour);
